exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footerContainer {\n    width: 100%;\n    background-color: #1DADFC;\n    height: 10rem;\n    text-align: center;\n    justify-self: flex-end;\n    margin-top: auto;\n}\n\n.footerLogo {\n    position: relative;\n    height: 50%;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n@media only screen and (max-width: 735px) {\n    .footerContainer {\n        height: 5rem;\n    }\n}\n", ""]);

// exports
